import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { ButtonTop, Loader } from '/src/components';
import { useStoreConfigContext } from '/src/providers';
import * as styles from './styles.scss';

const FormSearch = ({
    handleSearch,
    handleChange,
    handleClear,
    value,
    isLoading,
    products,
    clearProducts,
    isHover = true,
}) => {
    const {
        storeConfig: { product_url_suffix },
        translate,
    } = useStoreConfigContext();
    const [isOpen, setIsOpen] = useState(false);
    const isProducts = !!products?.length;

    return (
        <div className={styles.mid}>
            <div className={`${styles.mobile}${isOpen ? ` ${styles.open}` : ''}${isHover ? ` ${styles.fixed}` : ` ${styles.absolute}`}`}>
                <div className={styles.wrapper}>
                    <Loader isLoading={isLoading}>
                        <form
                            className={styles.form}
                            onSubmit={handleSearch}
                        >
                            <div className={styles.wrap}>
                                <input
                                    className={styles.input}
                                    placeholder={translate('Start your healthy eating journey here...')}
                                    type="text"
                                    name="search"
                                    value={value}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    aria-label="Search"
                                />
                                {
                                    !!value &&
                                    <button
                                        className={styles.clear}
                                        disabled={isLoading}
                                        onClick={handleClear}
                                        aria-label="Clear"
                                        type="button"
                                    />
                                }
                            </div>
                            <ButtonTop
                                className={styles.button}
                                disabled={isLoading}
                                aria-label="Search"
                            />
                            <button
                                className={styles.cancel}
                                onClick={() => setIsOpen(false)}
                                aria-label="Cancel"
                                type="button"
                            >
                                {translate('Cancel')}
                            </button>
                        </form>
                    </Loader>
                    {
                        isProducts &&
                        <div className={styles.products}>
                            {
                                products.map(({
                                    id,
                                    name,
                                    url_key,
                                    image: { label, url }
                                }) => (
                                    <div
                                        key={id}
                                        className={styles.product}
                                    >
                                        <img src={`${url}?d=80x80`} alt={label} width="80px" height="80px" />
                                        <Link to={`/${url_key}${product_url_suffix}`}>
                                            {name}
                                        </Link>
                                    </div>
                                ))
                            }
                            <button
                                className={styles.more}
                                onClick={handleSearch}
                            >
                                {translate('Show more')}
                            </button>
                        </div>
                    }
                </div>
                {
                    isHover &&
                    <div className={`${styles.hover}${isProducts ? ` ${styles.active}` : ''}`}>
                        <div onClick={clearProducts}/>
                    </div>
                }
            </div>
            <ButtonTop
                className={styles.search}
                onClick={() => setIsOpen(true)}
                aria-label="Search"
            />
        </div>
    );
};

export default FormSearch;
